export enum LanguageType {
  NL = 'NL',

  EN = 'EN',
}
